const getLogoSchema = (preTag) => ({
  type: `${preTag}_logo`,
});

const getNameSchema = (preTag) => ({
  type: `${preTag}_organization_name`,
});

const getAddressSchema = (preTag) => ({
  type: `${preTag}_organization_address`,
});

export default (params) => {
  const { preTag } = params;

  let schema;
  if (
    preTag === 'education' ||
    preTag === 'work_experience' ||
    preTag === 'awards_and_honors' ||
    preTag === 'volunteer_work' ||
    preTag === 'certifications' ||
    preTag === 'projects' ||
    preTag === 'research_experience' ||
    preTag === 'leadership' ||
    preTag === 'associations' ||
    preTag === 'extra_curricular' ||
    preTag === 'courses' ||
    preTag === 'conferences' ||
    preTag === 'references' ||
    preTag === 'patents' ||
    preTag === 'testScores'
  ) {
    schema = {
      nodes: [
        {
          match: { ...getLogoSchema(preTag) },
          min: 1,
          max: 1,
        },
        {
          match: { ...getNameSchema(preTag) },
          min: 1,
          max: 1,
        },
        {
          match: { ...getAddressSchema(preTag) },
          min: 1,
          max: 1,
        },
      ],
    };
  } else if (preTag === 'skill') {
    schema = {
      nodes: [
        {
          match: [getNameSchema(preTag)],
          min: 1,
          max: 1,
        },
      ],
    };
  }

  return { ...schema };
};
